import GradeVM from './grade-vm';
import GradeEntryVM from './grade-entry-vm';
import Fields from '../../../student/coursework/form_submission/fields';
import GradebookServices from '../services';
import GradeBreakdownChart from 'libs/grade-breakdown-chart';

export default function(args) {
  var self = this;

  self.placeholder = {
    visible: ko.observable(false),
    type: ko.observable('loading') //or 'no_results'
  };

  self.filter_options = ko.observable({
    'submissions': [
      'ungraded',
      'partially_graded',
      'not_submitted',
      'submitted',
      'student_action_required'
    ]
  });

  if (Kadenze.isKadenze)
    self.filter_options()['students'] = ['auditor', 'certificate'];

  self.params = {
    filters: ko.observableArray([])
  };

  self.coursework_id = ko.observable();
  self.student_id = ko.observable();
  self.all_student_ids = ko.observableArray([]);

  self.student = ko.observable();
  self.coursework = ko.observable();
  self.grade = ko.observable();
  self.grading_criteria = ko.observableArray();
  self.coursework_fields = ko.observableArray();

  self.selectedCriteria = ko.observable(); //Used by peer grades modal
  self.viewAllFields = ko.observable(false);

  self.showNotesTooltip = ko.observable(false);

  this.showStudentOptionsMenu = ko.computed(function() {
    return this.coursework() && (!this.coursework().coursework_submitted() ||
              this.coursework().coursework_placeholder_submitted() ||
                (this.student() && !this.student().has_certificate() &&
                  this.coursework().resubmittable_type() &&
                    !this.coursework().resubmittable()));
  }, this);

  this.reopenAllowed = ko.computed(function() {
    return this.student() && !this.student().has_certificate() &&
              this.coursework() && this.coursework().resubmittable_type() &&
                !this.coursework().resubmittable();
  }, this);

  this.markSubmittedVisible = ko.computed(function() {
    return this.coursework() && !this.coursework().coursework_submitted();
  }, this);

  this.markUnsubmittedVisible = ko.computed(function() {
    return this.coursework() && this.coursework().coursework_placeholder_submitted();
  }, this);

  this.gradePublished = ko.computed(function() {
    return this.coursework() && this.coursework().grade_published();
  }, this);

  this.gradeNotPublished = ko.computed(function() {
    return !this.gradePublished();
  }, this);

  self.ungraded_field_count = ko.computed(function () {
    if (self.coursework_fields()) {
      return _.reduce(
        self.coursework_fields(),
        function (memo, field) {
          return isNaN(parseInt(field.grade_entry.id())) ? (memo + 1) : memo;
        },
        0
      );
    }
  });

  self.calculated_percentage_live = ko.observable();
  self.grade_entry_mapping = {
    grade_entry: {
      create: function (options) {
        return new GradeEntryVM(options.data, options.parent, self);
      }
    }
  };

  self.closeSelectPicker = function () {
    if (!args.speed_grader) {
      self.$el.click(); //Hack to close selectpicker & menus
    }
  };

  self.initUI = function() {
    Kadenze.UIUtil.initExpandableText();
    if (!args.speed_grader) {
      self.initTypeahead();
      self.initCourseBreakdownChart();
    }
  };

  self.filterChanged = function () {
    self.closeSelectPicker();
    self.getFilterState();
    self.refreshURL();
  };

  self.getFilterState = function () {
    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.index_course_gradebook_students_path(
        self.course_id,
        self.coursework_id(),
        { filters: self.params.filters() }
      ),
      loadingIndicator: {}
    });

    request.done(function(response) {
      self.all_student_ids(response.student_ids);
      if(self.all_student_ids().length > 0) {
        self.placeholder.visible(false);
        // Load the first student from the list if,
        // there is no current student or if the current
        // one isn't in the filter group
        if (isNaN(parseInt(self.student_id())) ||
              !_.includes(self.all_student_ids(), parseInt(self.student_id()))) {
          self.student_id(self.all_student_ids()[0]);
        } else {
          self.initUI();
          // If we don't need to initGrader, then just trigger initUI manually
        }
      } else {
        self.placeholder.visible(true);
        self.placeholder.type('no_results');
      }
    });

    return request;
  };

  self.removeFilter = function(item, event) {
    self.params.filters.remove(item);
  };

  self.refreshURL = function () {
    if (self.coursework() && self.student() && !args.speed_grader) {
      var url = Kadenze.Routes.course_gradebook_student_grader_path(
        self.course_id,
        self.coursework().slug(),
        self.student().slug(),
        ko.mapping.toJS(self.params)
      );

      history.replaceState($.pjax.state, null, url);
    }
  };

  self.initCourseworkListing = function () {
    var coursework_listing = JSON.parse($('#coursework_listing_json').val());

    self.coursework_listing = ko.mapping.fromJS(coursework_listing);

    self.coursework_listing_families = ko.computed(function() {
      var list = ko.utils.arrayMap(self.coursework_listing(), function(cw){
        return cw['adaptive?']() ? cw.session_name() : cw.family_name();
      });

      return ko.utils.arrayGetDistinctValues(list);
    });
  };

  self.initGrader = function () {
    if (!isNaN(parseInt(self.coursework_id())) && !isNaN(parseInt(self.student_id()))) {
      Kadenze.UIUtil.showLoadingIndicator(self.$el, null, 'top');

      $.when(self.initStudentPanel(), self.initGradeListing()).done(function () {
        Kadenze.UIUtil.hideLoadingIndicator(self.$el);
        self.refreshURL();
        self.initUI();
        args.onReady();
      });
    }
  };

  self.initStudentPanel = function () {
    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.show_course_gradebook_students_path(
        self.course_id,
        {
          student_id: self.student_id(),
          coursework_id: self.coursework_id(),
          filters: self.params.filters()
        }
      )
    });

    request.done(function(response) {
      var mapped_student = ko.mapping.fromJS(response.student);
      self.student(mapped_student);

      var mapped_coursework = ko.mapping.fromJS(response.coursework);
      self.coursework(mapped_coursework);
    });

    return request;
  };

  self.initGradeListing = function () {
    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.index_course_gradebook_grade_entries_path(self.course_id, self.coursework_id(), self.student_id())
    });

    request.done(function(response) {
      //Bind grade object
      self.bindGrade(response.grade);

      //Bind grade entries
      if (response.coursework_fields) {
        //Grade entry VM is passed in here only to have the ability to clear grades from this grader VM
        //A seperate copy of grade entry VM will be used during quiz question rendering in initFormSubmissionVM
        var mapped_fields = ko.mapping.fromJS(response.coursework_fields, self.grade_entry_mapping);
        self.coursework_fields(mapped_fields());
      }
      if (response.grading_criteria) {
        var mapped_criteria = ko.mapping.fromJS(response.grading_criteria, self.grade_entry_mapping);
        self.grading_criteria(mapped_criteria());
      }

      self.selectedCriteria(null);
    });

    return request;
  };

  self.initFormSubmissionVM = function(element, field, force_refresh) {
    var type = field._type();
    var templateName = Kadenze.Util.snakeCase(type);
    var $container = $('#field-panel-' + field.id()).find('.kd-panel');
    var $fieldContainer = $container.find('.quiz-question');

    if (force_refresh && !_.isEmpty($fieldContainer.html())) {
      ko.cleanNode($container[0]);
    }

    if (_.isEmpty($fieldContainer.html()) || force_refresh) {
      var data = ko.mapping.toJS(field, {
        include: ['editing','just_saved']
      });
      var vm = Fields[type] ? new Fields[type](data, self.coursework(), self.grade_entry_mapping) :
        new Fields.BaseField(data, self.coursework(), false, self.grade_entry_mapping);
      vm.$index = function() { return 1; };
      vm.isPreviewing(true);
      vm.isGrading(true);

      var template = JST['templates/dynamic_fields/submission/' + templateName]({});
      $fieldContainer.html(template);

      ko.applyBindingsWithValidation(vm, $container[0], _.extend({}, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS, {insertMessages: false}));
    }
  };

  self.initTypeahead = function() {
    self.$searchEl = $('#student_search');

    //Mimick a placeholder text functionality for this contenteditable
    self.$searchEl.off('focus').on('focus', function () {
      self.$searchEl.css({minWidth: self.$searchEl.width()});
      self.$searchEl.val('');
    });

    self.$searchEl.off('blur').on('blur', function () {
      self.$searchEl.val(self.student().full_name());
    });

    //Hack to make contentent editables work with typeahead
    var original = $.fn.val;
    $.fn.val = function() {
      if ($(this).is('*[contenteditable]')) {
        return $.fn.html.apply(this, arguments);
      }
      return original.apply(this, arguments);
    };

    var url = Kadenze.Routes.search_course_gradebook_students_path(
      self.course_id,
      self.coursework_id(),
      {
        filters: self.params.filters(),
        search: '%QUERY',
      }
    );

    var studentSearch = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      limit: 5,
      remote: {
        url: url,

        filter: function(students) {
          return _.map(students, function(student) {
            return {
              id: student.id,
              name: student.full_name
            };
          });
        },

        ajax: {
          dataType: 'json',
          contentType: 'application/json',
          beforeSend: function() {
            //TODO: Show progress indicator
          },
          complete: function() {
            //TODO: Hide progress indicator
          }
        }
      }
    });

    studentSearch.initialize();

    self.$searchEl.typeahead({
      hint: false,
      highlight: true,
      minLength: 1
    },
    {
      name: 'students',
      displayKey: 'name',
      source: studentSearch.ttAdapter()
    });

    self.$searchEl.on('typeahead:selected', function(obj, datum) {
      self.student_id(datum.id);
    });
  };

  self.initCourseBreakdownChart = function () {
    $('#coursework_info_modal').off('shown.bs.modal').on('shown.bs.modal', function(){
      GradeBreakdownChart.init('horizontal');
    });
  };

  self.showStudent = function (student_id, nav_type) {
    if (_.isNumber(student_id)) {
      self.saveGrades(true).done(function () {
        self.student_id(student_id);
      });
    } else if (nav_type == 'next') {
      var filters = s.toSentenceSerial(_.map(self.params.filters(), function (f) { return s.humanize(f); }), ', ', ' or ');
      var filter_sentence = _.isEmpty(filters) ? '' : ' marked as: ' + filters;
      Kadenze.UIUtil.confirmAction('You\'ve gone through all entries in this coursework{filters}.'.supplant({filters: filter_sentence}), null, null, {
        title: `${I18n.t('course.gradebook.grader.all_done')}!`,
        ok_btn_text: I18n.t('course.gradebook.grader.ok_got_it'),
        hide_cancel: true,
        layout_type: 'icon',
        icon_class: 'check_mark_circle_colored'
      });
    }
  };

  self.showPeerGrades = function (item, event) {
    self.selectedCriteria(item);
    Kadenze.UIUtil.showModal('peer_grades_modal');
  };

  self.showPeerAssessments = function (item, event) {
    self.selectedCriteria(item);
    Kadenze.UIUtil.showModal('peer_assessments_modal');

    $('#peer_assessments_modal').on('hidden.bs.modal', function () {
      // If we close the modal popup directly it will not hide the tooltip
      // since it's hidden action is working on click
      $('.kadenze-tooltip').hide();
      self.removeClassFromNotesIcon();
    });
  };

  self.removeClassFromNotesIcon = function () {
    self.showNotesTooltip(false);
    $('.gradesheet-table__note-dark').removeClass('gradesheet-table__note-active');
  };

  self.addClassOnNotesIcon = function () {
    self.showNotesTooltip(true);
    $('.gradesheet-table__note-dark').addClass('gradesheet-table__note-active');
  };

  self.showParticipationArtifacts = function (item, event) {
    self.selectedCriteria(item);
    Kadenze.UIUtil.showModal('participation_artifacts_modal');
  };

  self.dateDisplay = (date) => {
    return date ? moment(date).format(I18n.t('date.formats.js_default_time')) : ''
  }

  self.downloadSubmission = function (item, event) {
    GradebookServices.downloadSubmission(item.coursework(), event);
  };

  self.openSubmission = function (item, event) {
    var msg = 'Are you sure you want to allow {student} to submit {coursework}'.supplant({student: self.student().full_name(), coursework: self.coursework().name_with_family_and_number()});
    GradebookServices.openSubmission(self.coursework(), event, msg);
    self.closeSelectPicker();
  };

  self.markAsSubmitted = function (item, event) {
    GradebookServices.markAs(self.coursework(), event, 'submitted');
    self.closeSelectPicker();
  };

  self.markAsUnsubmitted = function (item, event) {
    GradebookServices.markAs(self.coursework(), event, 'unsubmitted');
    self.closeSelectPicker();
  };

  self.allowStudentPlagiarismVisibility = function(item, event) {
    GradebookServices.allowStudentPlagiarismVisibility(item.coursework(), event);
  };

  self.reRunPlagiarismDetection = function(item, event) {
    GradebookServices.reRunPlagiarismDetection(item.coursework(), event);
  };

  self.rerunAutoGrading = function () {
    GradebookServices.presentAutoGradingOption(self.hasOverriddenGradeEntriesWithScope(['instructor', 'autograder']), function () {
      GradebookServices.rerunAutoGrading(self.course_id, self.coursework().entry.id(), false);
    }, function () {
      GradebookServices.rerunAutoGrading(self.course_id, self.coursework().entry.id(), true);
    });
    self.closeSelectPicker();
  };

  self.rerunAllAutoGrading = function () {
    GradebookServices.presentAutoGradingOption(self.coursework().has_overridden_grade_entries(), function () {
      GradebookServices.rerunAllAutoGrading(self.course_id, self.coursework_id(), false);
    }, function () {
      GradebookServices.rerunAllAutoGrading(self.course_id, self.coursework_id(), true);
    });
    self.closeSelectPicker();
  };

  self.clearGrades = function (scope) {
    var promises = [];
    var iterator = self.coursework().form_builder_type() ? self.getFieldsWithScope(scope) : self.getCriteriaWithScope(scope);
    _.each(iterator, function (o) {
      if (!isNaN(parseInt(o.grade_entry.id()))) {
        promises.push(o.grade_entry.deleteGradeEntry());
      }
    });
    $.when(promises).done(function () {
      new Kadenze.Notice.success({});
    });
    self.closeSelectPicker();
  };

  self.getGradeEntryVMs = function () {
    if (self.coursework().form_builder_type()) {
      // This is grabbing the VM from the DOM and not from field.grade_entry
      // because it will have the unsaved state need to auto-save on navigate
      return _.compact(_.map(self.getFields(), function (field) {
        var $container = $('#field-panel-' + field.id()).find('.kd-panel');
        if (!_.isEmpty($container)) {
          var vm = ko.dataFor($container[0]);
          if (vm) {
            return vm.grade_entry;
          }
        }
      }));
    } else {
      return _.map(self.grading_criteria(), function (criterion) {
        return criterion.grade_entry;
      });
    }
  };

  self.saveGrades = function(silent) {
    // Used for auto-save upon closing or navigation
    // Persist any unsaved grade entries
    var saveGradeEntries = function () {
      var deferred = $.Deferred();
      var grade_entries = self.getGradeEntryVMs();
      _.each(grade_entries, function(grade_entry) {
        if (grade_entry.editing()) {
          grade_entry.save(silent);
        }
      });
      deferred.resolve();
      return deferred;
    };

    if (self.grade().editing()) {
      // If the grade is unsaved, persist that first,
      // before saving it's entries
      var deferred = $.Deferred();
      saveGradeEntries().done(function () {
        self.grade().save(silent).done(deferred.resolve);
      });
    } else {
      deferred = saveGradeEntries();
    }

    return deferred;
  };

  self.bindUpdates = function (data) {
    //Any properties that could change after saving a grade entry should go here
    self.grade().calculated_percentage(data.calculated_percentage);
    self.grade().total_points(data.total_points);
    self.grade().last_graded_at(data.last_graded_at);
    self.grade().compiled_auto_grade_notes(data.compiled_auto_grader_notes);

    self.coursework().score(data.calculated_percentage);
    self.coursework().resubmittable(data.resubmittable);
  };

  self.bindGrade = function (grade) {
    var grade_mapping = {
      create: function (options) {
        return new GradeVM(options.data, self);
      }
    };
    var mapped_grade = ko.mapping.fromJS(grade, grade_mapping);
    self.grade(mapped_grade);
  };

  self.hasParticipationArtifacts = function (scope) {
    var r = Kadenze.Util.objFromString;
    var artifacts = r(self.selectedCriteria(), 'grade_entry.participation_artifacts.' + scope, ko.observableArray());
    return artifacts().length > 0;
  };

  self.getParticipationArtifacts = function (scope) {
    var r = Kadenze.Util.objFromString;
    var artifacts = r(self.selectedCriteria(), 'grade_entry.participation_artifacts.' + scope, ko.observableArray());
    return artifacts();
  };

  self.hasGradeEntriesWithScope = function(scopes) {
    scopes = _.isArray(scopes) ? scopes : [scopes];
    var iterator = self.coursework().form_builder_type() ? self.getFieldsWithScope(scopes) : self.getCriteriaWithScope(scopes);
    return _.any(iterator, function (o) { return !isNaN(parseInt(o.grade_entry.id())); });
  };

  self.getGradeEntriesWithScope = function(scopes) {
    scopes = _.isArray(scopes) ? scopes : [scopes];
    var iterator = self.coursework().form_builder_type() ? self.getFieldsWithScope(scopes) : self.getCriteriaWithScope(scopes);
    return _.map(iterator, function (o) { return o.grade_entry; });
  };

  self.hasOverriddenGradeEntriesWithScope = function (scopes) {
    scopes = _.isArray(scopes) ? scopes : [scopes];
    return _.any(self.getGradeEntriesWithScope(scopes), function (entry) {
      return !entry.average() && entry.overridden();
    });
  };

  self.hasCriteriaWithScope = function(scopes) {
    scopes = _.isArray(scopes) ? scopes : [scopes];
    return _.any(self.grading_criteria(), function (criterion) { return _.includes(scopes, criterion.scope()); });
  };

  self.hasAutoGradedCriteria = function () {
    //TODO: Look into using the back-end version of this Coursework#has_autograde_criteria?
    var autograded_criteria = false;
    if(self.coursework().form_builder_type()) {
      var total_count = self.coursework_fields().length;
      var manually_graded_count = self.getManuallyGradedFields().length;
      autograded_criteria = ((total_count - manually_graded_count) > 0);
    } else {
      autograded_criteria = self.hasCriteriaWithScope('autograder');
    }
    return autograded_criteria;
  };

  self.getCriteriaWithScope = function(scopes) {
    scopes = _.isArray(scopes) ? scopes : [scopes];
    return _.select(self.grading_criteria(), function (criterion) { return _.includes(scopes, criterion.scope()); });
  };

  this.downloadXapiResponse = () => {
    window.location.href = Kadenze.Routes.xapi_download_response_path(
      {
        format: 'json',
        statement: {
          student_id: this.student().id(),
          coursework_id: this.coursework().id(),
        },
      }
    );
  };

  self.getManuallyGradedFields = function () {
    var manual_types = ['FillInTheBlankField','WrittenResponseField'];
    return _.filter(self.coursework_fields(), function(field) { return ((!field.grade_entry || !field.grade_entry.autograde()) && _.contains(manual_types, field._type())); });
  };

  self.getFieldsWithScope = function(scopes) {
    scopes = _.isArray(scopes) ? scopes : [scopes];
    return _.select(self.coursework_fields(), function (field) { return _.includes(scopes, field.grading_criteria.scope()); });
  };

  self.getFields = ko.computed(function () {
    return _.select(self.coursework_fields(), function (field) { return self.viewAllFields() || (field.grade_entry.just_saved() || isNaN(parseInt(field.grade_entry.id()))); });
  });

  self.nextStudentId = ko.computed(function () {
    var current_index = self.all_student_ids.indexOf(parseInt(self.student_id()));
    return self.all_student_ids()[current_index + 1];
  });

  self.prevStudentId = ko.computed(function () {
    var current_index = self.all_student_ids.indexOf(parseInt(self.student_id()));
    return self.all_student_ids()[current_index - 1];
  });

  self.studentPosition = ko.computed(function () {
    var pos = s.numberFormat(self.all_student_ids.indexOf(parseInt(self.student_id())) + 1);
    var total = s.numberFormat(self.all_student_ids().length);
    return '{pos} of {total}'.supplant({pos: pos, total: total});
  });

  self.gradeBreakdownTooltipParams = function () {
    return {
      weight: self.coursework().weight.extend({ numberToPercentage: 2 })(),
      overall_weight: self.coursework().overall_weight.extend({ numberToPercentage: 2 })(),
      grading_policy_name: self.coursework().grading_policy_name()
    };
  };

  self.postGradeForStudent = function(item, event) {
    var msg = I18n.t('js.post_grade_message');
    self.gradeForStudent(item, msg);
  };

  self.draftGradeForStudent = function(item, event){
    var msg = I18n.t('js.draft_grade_message');
    self.gradeForStudent(item, msg);
  };

  self.gradeForStudent = function(item, msg) {
    Kadenze.UIUtil.confirmAction(msg, function () {
      var url = Kadenze.Routes.course_coursework_post_or_draft_grade_path(self.course_id, item.coursework_id());
      var request = new Kadenze.AjaxRequest({
        url: url,
        type: 'PATCH',
        data: {student_id: item.student_id()},
        loadingIndicator: {
          container: self.$el
        }
      });

      request.done(function(response, status, xhr) {
        self.coursework().grade_published(response.grade.published);
        new Kadenze.Notice.success({message: response.message});
      });
  
      request.fail(function(xhr, status, msg) {
        new Kadenze.Notice.error({message: response.message});
      });
    });
  };

  const __construct = function(that) {
    that.$el = args.$el;
    that.course_id = args.course_id;
    that.coursework_id(args.coursework_id);
    that.student_id(args.student_id);

    //This will manage the filter state at all times
    that.params.filters(args.filters);
    that.params.filters.subscribe(self.filterChanged);
    //Trigger this on page load if there are no filters just to get the total count
    //otherwise this will be triggered via the subscription of coursework_id below
    if (self.params.filters().length == 0 || args.speed_grader) {
      self.filterChanged();
    }

    if (args.speed_grader) {
      //In quick grading mode, directly initGrader
      that.initGrader();
    } else {
      //In full mode, loading of the coursework drop-down will trigger
      //the coursework_id subscription below which in turn will trigger initGrader
      that.initCourseworkListing();
    }

    //Update student panel and grade listing if student or coursework changes
    that.student_id.subscribe(that.initGrader);
    that.coursework_id.subscribe(function() {
      //If a filter is on, re-load the filter state when the coursework is changed
      if (self.params.filters().length > 0) {
        that.getFilterState().done(that.initGrader);
      } else {
        that.initGrader();
      }
    });
  }(this);
}
